module.exports = {"430621100":"荣家湾镇","430621104":"黄沙街镇","430621105":"新墙镇","430621106":"柏祥镇","430621107":"筻口镇","430621108":"公田镇","430621109":"毛田镇","430621110":"月田镇","430621111":"张谷英镇","430621112":"新开镇","430621113":"步仙镇","430621114":"杨林街镇","430621202":"中洲乡","430621203":"长湖乡","430621500":"东洞庭湖管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430621.json
// module id = 1988
// module chunks = 0